export const navOptions = [
  { name: "SERWIS", path: "#service", isScroll: true },
  { name: "PRODUKTY", path: "#products", isScroll: true },
  { name: "O NAS", path: "#about", isScroll: true },
  { name: "KONTAKT", path: "#contact", isScroll: true },
];
